import { Box, styled, Typography, TypographyProps } from '@mui/material';
import { error as errorColor, primary, text } from 'assets/colors/colors';

export const StyledTypography = styled(
  (props: TypographyProps & { $isFloating: boolean; $error: boolean }) => (
    <Typography {...props} />
  ),
)(({ $isFloating, $error }) => ({
  position: 'absolute',
  top: $isFloating ? '-8px' : '8px',
  left: $isFloating ? '12px' : '32px',
  fontSize: $isFloating ? '11px' : '14px',
  color: $error ? errorColor.main : text.secondary,
  transition: 'all 0.175s ease-out',
  pointerEvents: 'none',
  zIndex: 2,
  display: 'block',
  backgroundColor: $isFloating ? primary.contrastText : 'transparent',
  padding: '0 5px',
}));

export const StyledWrapper = styled(Box)({
  position: 'relative',
  '&:active, &:focus-within': {
    '& .label-shrink': {
      color: primary.main,
    },
  },
});
